import * as React from 'react';
import FormView from '../../FormView';
import { IDiaryProperties } from '../interfaces';

class Diary extends React.PureComponent<IDiaryProperties> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/purchase-order-enquiry/purchase-diary':
          onInitialLoad('SalesDiary');
          break;
        case '/purchase-order-enquiry/purchase-diary/diary-details':
          onInitialLoad('DiaryDetails');
          break;
        default:
          onInitialLoad('OrderDetails');
      }
    }
  }

  getInitialValues = () => {
    const {
      selectedOrder
    } = this.props;
    const params = (new URLSearchParams(location.search));
    const purchaseOrder = (selectedOrder && selectedOrder.PurchaseOrder) || params.get('PurchaseOrder');

    return {
      params: purchaseOrder && {
        PurchaseOrder: purchaseOrder,
      }
    };

  };

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, operationMode, isLoading } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <FormView
          isLoading={isLoading}
          formName={(selectedTab === 'SalesDiary' && 'Diary') || selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          initialValues={this.getInitialValues()}
          operationMode={operationMode}
          enableReinitialize={true}
        />
      </React.Fragment>
    );
  }
}

export default Diary;
